import { get, post } from '../client/client';
import { endpoint } from '../endpoint';
import type {
  PaymentCreate,
  PaymentManagementResponse,
  PageQuery,
  PaymentPagination,
  PaymentPublic,
} from '../type/payment';

export const createPayment = async (payload: PaymentCreate) => {
  return await post<PaymentPublic, PaymentCreate>(endpoint.createPayment, payload);
};


export const getPolicyPayments = async (policyId: number) => {
  return await get<PaymentPagination>(endpoint.getPolicyPayments(policyId));
};

export const getPaymentsManagement = async (params: PageQuery) => {
  return await get<PaymentManagementResponse>(endpoint.getPaymentsManagement, { params });
};
